export default "__VITE_ASSET__CTTs8bv1__"